module.exports = __webpack_public_path__ + "4478b4d7022cad174e4c04246fe622ef.svg";